import moment from "moment";
import React, { useState } from "react";
import BootcampPurchaseModal from "../../purchaseModal/bootcampPurchaseModal";
import PaymentModal from "../webinar/PaymentModal";
import { useSelector } from "react-redux";
import Loader from "../../../loader";

const BootcampPage = ({ bootCampData, handleClickNext, handleClickPrevious }) => {
  const [activeTab, setActiveTab] = useState(0);
  const { isLoading } = useSelector((state) => state?.coach?.auth);
  const [isWaitList, setIsWaitList] = useState(false);
  const [isPurchse, setIsPurchase] = useState(false);

  const [isPaymentShow, setIsPaymentShow] = useState(false);
  const [bootCampId, setBootCampId] = useState("");

  const activeProgramDay =
    bootCampData?.program_days?.length > 0
      ? bootCampData?.program_days[activeTab]
      : [];

  const formattedDate = `${moment(bootCampData?.start_date).format(
    "DD MMM YYYY"
  )} - ${moment(bootCampData?.end_date).format("DD MMM YYYY")}`;

  const handleModalOpen = (item) => {
    setBootCampId(item?.bootcamp_id);
    if (item?.available_seats == 0) {
      setIsWaitList(true);
    } else {
      setIsPurchase(true);
    }
  };

  if (isLoading) {
    return <Loader />;
  };
  return (
    <>
      <section class="ct_px_40 mt-5  position-relative ">
        <div class="container-fluid">
          <div class="row align-items-center">
            <div class=" col-md-12">
              <div
                class="ct_px_40 ct_px_0_767 ct_bootcamp_banner_123 "
                style={{
                  backgroundImage: `url(${bootCampData?.header_image || ""})`,
                }}
              >
                <h2 class="ct_fs_48 mb-0 text-white text-center">
                  {" "}
                  <span class="ct_yellow_text">
                    {bootCampData?.header_title || ""}
                  </span>
                </h2>
                <p
                  class="mb-0 mt-2 ct_fs_20  text-center ct_text_clr_8ECAE6 mx-auto"
                  style={{ maxWidth: "680px" }}
                >
                  {bootCampData?.header_sub_title}
                </p>

                <ul class="d-flex align-items-center gap-3 gap-md-5 mt-4 pt-2 px-3">
                  <li class="ct_fs_20  d-sm-flex d-grid text-sm-start text-center align-items-center gap-3 text-white">
                    <img
                      src="assets/img/light_blue_clock.png"
                      alt=""
                      className="mx-auto"
                    />{" "}
                    {formattedDate}
                  </li>
                  <li class="ct_fs_20 d-sm-flex d-grid text-sm-start text-center  align-items-center gap-3 text-white">
                    {" "}
                    <img
                      src="assets/img/light_blue_location.png"
                      alt=""
                      className="mx-auto"
                    />{" "}
                    {bootCampData?.location || ""}
                  </li>
                </ul>


              </div>
            </div>
          </div>
        </div>
        <div className="ct_custom_slider_icons">
          <button className="ct_prev_icon" onClick={handleClickNext}><i class="fa-solid fa-angle-left"></i></button>
          <button className="ct_next_icon" onClick={handleClickPrevious}><i class="fa-solid fa-angle-right"></i></button>
        </div>
      </section>

      <section class="mt-5 pt-4 ct_px_40">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12">
              <h4 class="ct_fs_24">
                <span class="ct_orange_text">
                  {activeProgramDay?.title || ""} :
                </span>{" "}
                {activeProgramDay?.description || ""}
              </h4>

              <div class="ct_event_tab_bg_34">
                <ul
                  class="nav nav-pills mb-3 ct_custom_tabs w-100 px-5 ct_border_radius_20"
                  id="pills-tab"
                  role="tablist"
                >
                  {bootCampData?.program_days?.map((item, index) => {
                    return (
                      <li class="nav-item" role="presentation">
                        <button
                          class={`nav-link ${activeTab == index ? "active" : ""
                            }`}
                          id="pills-DAY_1-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-DAY_1"
                          type="button"
                          role="tab"
                          aria-controls="pills-DAY_1"
                          aria-selected="true"
                          onClick={() => {
                            setActiveTab(index);
                          }}
                        >
                          DAY {index + 1}
                        </button>
                      </li>
                    );
                  })}
                </ul>

                <div class="tab-content px-4" id="pills-tabContent">
                  <div
                    class="tab-pane fade active show"
                    id="pills-DAY_1"
                    role="tabpanel"
                    aria-labelledby="pills-DAY_1-tab"
                  >
                    <div class="table-responsive ct_event_table_3">
                      <table class="table ">
                        <tbody>
                          {activeProgramDay?.sessions?.length > 0 &&
                            activeProgramDay?.sessions?.map((item, index) => {
                              return (
                                <>
                                  <tr className="ct_first_td_tr_bg">
                                    <td>{item?.date}</td>
                                    <td>
                                      <strong>{item?.start_time}</strong>
                                    </td>
                                    <td>
                                      <span
                                        className="ct_para_scroll text-wrap ct_custom_scroll d-inline-block"
                                        style={{
                                          maxHeight: "148px",
                                          width: "350px",
                                        }}
                                      >
                                        {item?.title || ""}
                                      </span>
                                    </td>
                                    <td class="text-center ct_collaspse_btn2">
                                      <a
                                        class="ct_yellow_text"
                                        data-bs-toggle="collapse"
                                        data-bs-target={`#detail${index}`}
                                      ></a>
                                    </td>
                                  </tr>
                                  <tr
                                    id={`detail${index}`}
                                    class="collapse collapse-row"
                                  >
                                    <td
                                      colSpan={4}
                                      style={{
                                        verticalAlign: "middle",
                                        whiteSpace: "normal",
                                      }}
                                    >
                                      <p className="ct_fs_18 mb-0 ct_para_scroll ct_custom_scroll">
                                        {" "}
                                        {item?.description || ""}
                                      </p>
                                      {item?.speakers?.length > 0 && (
                                        <div className="d-flex align-items-center gap-3 mt-4">
                                          <h5 className="ct_fs_24 ct_fw_600 ct_darkblue_text mb-0 ct_white_nowrap">
                                            Speakers :
                                          </h5>
                                          <ul className="d-flex align-items-center gap-3 flex-wrap ct_para_scroll ct_custom_scroll">
                                            {item?.speakers?.map(
                                              (speaker, sindex) => (
                                                <li>
                                                  <div
                                                    className="ct_light_grey_bg d-flex align-items-center gap-3"
                                                    style={{
                                                      background: "#f9f9f9",
                                                    }}
                                                  >
                                                    <img
                                                      src={
                                                        speaker?.image ||
                                                        "/assets/img/user_profile.png"
                                                      }
                                                      className="ct_img_40 ct_flex_shrink_0 mb-0"
                                                    />
                                                    <div>
                                                      <h4 className="ct_fs_20 ct_fw_600 ct_darkblue_text mb-0">
                                                        {speaker?.name ||
                                                          "#N/A"}
                                                      </h4>
                                                      <p className="mb-0 ct_text_op_8 ct_fs_16 ct_darkblue_text">
                                                        {speaker?.role ||
                                                          "#N/A"}
                                                      </p>
                                                    </div>
                                                  </div>
                                                </li>
                                              )
                                            )}
                                          </ul>
                                        </div>
                                      )}
                                    </td>
                                  </tr>
                                </>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="ct_turning_idea_dark_blue_bg ct_px_40" style={{ backgroundColor: bootCampData?.footer_color || "#023047" }}>
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12">
              <h2
                class="ct_fs_60 cti_white_text mb-0"
                style={{ maxWidth: "1200px" }}
              >
                {bootCampData?.footer_title || ""}
              </h2>
            </div>
          </div>

          <div class="row align-items-center mt-5">
            <div
              class="col-xxl-5 col-xl-5 col-md-5 mb-4 mb-md-0 aos-init aos-animate"
              data-aos="fade-right"
              data-aos-duration="1500"
            >
              <div class="ct_boocamp_img_left">
                <img
                  style={{ objectPosition: "right" }}
                  src={bootCampData?.footer_image || ""}
                  alt=""
                  class="ct_img_h_512 w-100 ct_border_radius_32"
                />
              </div>
            </div>
            <div
              class="col-xxl-7 col-xl-7 col-md-7 mb-4 mb-md-0 aos-init aos-animate"
              data-aos="fade-left"
              data-aos-duration="1500"
            >
              <div class="ct_px_40 ct_px_0_767">
                <h2 class="ct_fs_36 mb-4 ct_fw_300 cti_white_text">
                  {bootCampData?.footer_sub_title || ""}
                </h2>
                {/* <h2 class="ct_fs_36 mb-2 ct_orange_text">
                  A Journey in Innovation & Creativity
                </h2> */}
                <p
                  class="mb-0 mt-2 ct_fs_18 ct_fw_300 text-white"
                  style={{ maxWidth: "596px" }}
                >
                  {bootCampData?.footer_description}
                </p>
                <div class="mt-5">
                  <a
                    class="ct_yellow_btn ct_sky_blue_btn px-5 ct_fit_content ct_h_48"
                    onClick={() => handleModalOpen(bootCampData)}
                  >
                    Get your seat{" "}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {isPurchse && bootCampId && (
        <BootcampPurchaseModal
          onClose={() => setIsPurchase(false)}
          ID={bootCampId}
          handleClose={() => {
            setIsPurchase(false);
            setIsPaymentShow(true);
          }}
        />
      )}
      {isPaymentShow && (
        <PaymentModal onClose={() => setIsPaymentShow(false)} />
      )}
    </>
  );
};

export default BootcampPage;
